<template>
  <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main">
    <div class="container-fluid">
      <!-- Toggler -->
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#sidenav-collapse-main" aria-controls="sidenav-main" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <!-- Brand -->
      <img @click="changeDashboardMode('Introduction')" src="http://labs.orbitist.com/cclbc2018/img/cclbc_logo.png" class="sidenav-logo clickable" alt="Land Bank Logo">
      <!-- Collapse -->
      <div class="collapse navbar-collapse" id="sidenav-collapse-main">
        <!-- Collapse header -->
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <a href="./index.html">
                <img src="../assets/img/brand/blue.png">
              </a>
            </div>
            <div class="col-6 collapse-close">
              <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#sidenav-collapse-main" aria-controls="sidenav-main" aria-expanded="false" aria-label="Toggle sidenav">
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>

        <!-- Navigation -->
        <ul class="navbar-nav">
          <li class="nav-item" @click="changeDashboardMode('Introduction')">
            <div class="nav-link clickable">
              <i class="fal fa-home"></i> Introduction
            </div>
          </li>
          <li class="nav-item" @click="changeDashboardMode('Mission')">
            <div class="nav-link clickable">
              <i class="fal fa-handshake-alt"></i> Mission
            </div>
          </li>
          <li class="nav-item" @click="changeDashboardMode('Problem')">
            <div class="nav-link clickable">
              <i class="fal fa-exclamation-circle"></i> Problem
            </div>
          </li>
          <li class="nav-item" @click="changeDashboardMode('Work')">
            <div class="nav-link clickable">
              <i class="fal fa-briefcase"></i> 2018 Work
            </div>
          </li>
          <li class="nav-item" @click="changeDashboardMode('Outcomes')">
            <div class="nav-link clickable">
              <i class="fal fa-chart-line"></i> Outcomes
            </div>
          </li>
          <li class="nav-item" @click="changeDashboardMode('Team')">
            <div class="nav-link clickable">
              <i class="fal fa-users"></i> Team
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    methods: {
      changeDashboardMode(mode) {
        this.$emit('changeDashboardMode', mode)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sidenav.vue